<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">Export data PO Indomaret</div>
      <div v-if="loading == true">
        <div class="sk-spinner sk-spinner-pulse"></div>
        <p class="text-center" style="color: #CCC;">Please wait . . .</p>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>

        <div class="col-lg-12">
            <small>Data ini, digunakan pada <a href="https://planner.myrouteonline.com/route-planner/1812/#" target="_blank">Route Planner</a> untuk membuat rute dari PO Indomaret</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "report_po",
  data() {
    return {
      loading: false
    };
  },
  methods: {
    init: function() {
      //this.getDropdown();
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        window.location.href = axios.defaults.baseURL+'web/export/po_indomaret/';
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
